import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

export const initApexAutoSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".apex-auto-slider__swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((sliderElement) => {
    // Avoid double initialization
    if (sliderElement.dataset.initialized === "true") return;
    sliderElement.dataset.initialized = "true";

    new Swiper(sliderElement, {
      modules: [Autoplay],
      loop: true,
      spaceBetween: 20, // 20px gap as seen in the design
      allowTouchMove: true,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true, // Stops scrolling when the user hovers over a card
      },
      breakpoints: {
        320: { slidesPerView: 1.2 }, // Show a bit of the next slide on mobile
        540: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },
    });
  });

  console.log("[ApexAutoSlider] Initialized.");
};
